<template>
  <b-row>
    <b-col lg="12">
      <!-- .name -->
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
          <b-row>
            <b-col lg="6" class="mb-md-0 mb-2">  
              <b-col lg="12" class="mb-md-0 mb-2">              
              <b-form-group
                id="input-group-1"
                :label="$t('notificationsActions.name')"
                label-for="input-1"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('notificationsActions.name')"
                  vid="notificationsActions_name"
                  rules="required"
                >              
                <b-form-input
                  id="input-1"
                  v-model="newItem.name"
                  type="text"
                  :placeholder="$t('notificationsActions.name')"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>                
              </b-form-group>
              </b-col>
              <b-col lg="12" class="mb-md-0 mb-2">              
              <b-form-group
                id="input-group-1"
                :label="$t('notificationsActions.category')"
                label-for="input-1"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('notificationsActions.category')"
                  vid="notificationsActions_category"
                  rules="required"
                >              
                <!-- <b-form-input
                  id="input-1"
                  v-model="newItem.category"
                  type="text"
                  :placeholder="$t('notificationsActions.category')"
                  :state="errors.length > 0 ? false : null"
                /> -->
                <v-select
                  v-model="newItem.category"
                  :options="categories"
                  class="w-100"
                  label="category"
                  :reduce="(category) => category"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>                
              </b-form-group>
              <!--  -->
            </b-col>
            </b-col>
            <b-col lg="6" >              
              <b-form-group
                id="input-group-1"
                :label="$t('notificationsActions.enable_sms')"
                label-for="input-1"
              >      
                <b-form-checkbox
                      v-model="newItem.enable_sms"
                      class="custom-control-success"
                      name="check-button"
                      value="1"
                      switch
                />  
              </b-form-group>  
              <b-form-group
                id="input-group-1"
                :label="$t('notificationsActions.enable_notification')"
                label-for="input-1"
              >      
                <b-form-checkbox
                      v-model="newItem.enable_notification"
                      class="custom-control-info"
                      name="check-button"
                      value="1"
                      @change="changeActive(data.item,'enable_notification')"
                      switch
                /> 
              </b-form-group>
              <b-form-group
                id="input-group-1"
                :label="$t('notificationsActions.enable_email')"
                label-for="input-1"
              >       
                <b-form-checkbox
                      v-model="newItem.enable_email"
                      class="custom-control-primary"
                      name="check-button"
                      value="1"
                      switch
                />        
              </b-form-group>
              
            </b-col>
            <b-col lg="12" class="mb-md-0 mb-2">              
              <b-form-group
                id="input-group-1"
                :label="$t('notificationsActions.sms')"
                label-for="input-1"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('notificationsActions.sms')"
                  vid="notificationsActions_sms"
                  rules="required"
                >              
                <ckeditor
                  :config="{ contentsLangDirection: 'rtl',versionCheck : false }"
                  v-model="newItem.sms"
                  :placeholder="$t('notificationsActions.sms')"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>                
              </b-form-group>
              
            </b-col>
            <b-col lg="12" class="mb-md-0 mb-2">              
              <b-form-group
                id="input-group-1"
                :label="$t('notificationsActions.notifiaction')"
                label-for="input-1"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('notificationsActions.notifiaction')"
                  vid="notificationsActions_notification"
                  rules="required"
                >              
                <ckeditor
                  :config="{ contentsLangDirection: 'rtl',versionCheck : false }"
                  v-model="newItem.notification"
                  :placeholder="$t('notificationsActions.notifiaction')"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>                
              </b-form-group>
              
            </b-col>
            <b-col lg="12" class="mb-md-0 mb-2">              
              <b-form-group
                id="input-group-1"
                :label="$t('notificationsActions.email')"
                label-for="input-1"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('notificationsActions.email')"
                  vid="notificationsActions_email"
                  rules="required"
                >              
                <ckeditor
                  :config="{ contentsLangDirection: 'rtl',versionCheck : false }"
                  v-model="newItem.email"
                  :placeholder="$t('notificationsActions.email')"
                  :state="errors.length > 0 ? false : null"
                />                
                <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>                
              </b-form-group>
              
            </b-col>
          </b-row>

          <hr />
          <b-row>
            <b-col lg="6">
              <b-button
                block
                :disabled="invalid"
                variant="primary"
                @click="submit()"
              >
                <i class="fa fa-plus" /> {{ $t("site.save") }}</b-button
              >
            </b-col>
            <b-col lg="6">
              <b-button block @click="goToTable()" variant="success">
                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}</b-button
              >
            </b-col>
          </b-row>
        </b-form></validation-observer
      >
    </b-col>
    
  </b-row>
</template>

<script>
import Controller from '@/Controllers/NotificationsActionsController'
 import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import vSelect from "vue-select";
const controller = new Controller()
export default {
  name: 'NotificationsactionsForm',
  components: {
    vSelect,
    ValidationProvider,
    ValidationObserver,
    required,
   },
  props: ['newItem'],
  data() {
    return {
      file: {},
      categories:['announcement','assessment','exam','lecture','master','poll','new_user','program_register','activity','correct_activity','activity_answer','room']
    }
  },
  methods: {
       goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      controller.From(this.newItem, 'FormData')
       this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
       this.$parent.$parent.firstTab();
    },
    // async created() {
    //    const data = await controller.created();
    //    data.
    // },

  },

}
</script>
